import { render, staticRenderFns } from "./FareSeasonalityRules.vue?vue&type=template&id=44472ab5&scoped=true&"
import script from "./FareSeasonalityRules.vue?vue&type=script&lang=js&"
export * from "./FareSeasonalityRules.vue?vue&type=script&lang=js&"
import style0 from "./FareSeasonalityRules.vue?vue&type=style&index=0&id=44472ab5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44472ab5",
  null
  
)

export default component.exports